var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.529 15.222c.297.155.644.155.941 0 1.57-.819 6.529-3.787 6.529-8.613a3.847 3.847 0 0 0-3.826-3.859A3.88 3.88 0 0 0 9 4.47a3.88 3.88 0 0 0-3.173-1.72 3.847 3.847 0 0 0-3.826 3.859c0 4.826 4.958 7.794 6.528 8.613"
  })));
};
export default SvgHeart;